import api from '../api'

export type TermsCheck = {
  needsAcceptance: boolean
  changeDescription: string
}

export const getTermsCheck = async (): Promise<TermsCheck> => {
  const response = await api.get<TermsCheck>('/web/terms/check')
  return response.data
}

export const acceptTerms = async (): Promise<void> => {
  await api.post('/web/terms/accept')
}
